import React from 'react';
import { Sparkles } from 'lucide-react';

// Castle images per course number
const CASTLE_IMAGES = {
  1: 'https://customer-assets.emergentagent.com/job_38aae9fa-7a73-49f8-925c-644968c5b048/artifacts/zw8ogxr4_Medieval%20stone%20castle%20with%20flag%20and%20forge%2050%201.png',
  2: 'https://customer-assets.emergentagent.com/job_38aae9fa-7a73-49f8-925c-644968c5b048/artifacts/6tqn7eqr_Medieval%20castle%20with%20glowing%20torches%2050%202.png',
  3: 'https://customer-assets.emergentagent.com/job_38aae9fa-7a73-49f8-925c-644968c5b048/artifacts/qijxnosy_Medieval%20castle%20with%20glowing%20forge%2050%203.png',
  4: 'https://customer-assets.emergentagent.com/job_38aae9fa-7a73-49f8-925c-644968c5b048/artifacts/u8397843_Dragon%20over%20fiery%20castle%20keep%2050%204.png',
};

/**
 * CastleTop - The destination castle at the top of the path
 */
export default function CastleTop({ 
  courseNumber = 1,
  lessonNumber = 25,
  title = "The Reforge",
  isUnlocked = false,
  onClick
}) {
  const isFinalCourse = courseNumber === 4;
  const castleTitle = isFinalCourse ? "The Dragon Keep" : title;
  const imageUrl = CASTLE_IMAGES[courseNumber] || CASTLE_IMAGES[1];

  // Scale increases per course
  const size = {
    1: 'w-60 h-60',
    2: 'w-[17.6rem] h-[17.6rem]',
    3: 'w-[20.4rem] h-[20.4rem]',
    4: 'w-[23.04rem] h-[23.04rem]',
  }[courseNumber] || 'w-60 h-60';

  return (
    <div className="relative flex flex-col items-center pt-8 pb-6">
      {/* Background glow */}
      <div 
        className="absolute top-4 left-1/2 -translate-x-1/2 w-48 h-48 rounded-full blur-3xl -z-10"
        style={{
          background: isUnlocked 
            ? 'radial-gradient(circle, rgba(251, 191, 36, 0.25) 0%, transparent 70%)'
            : 'radial-gradient(circle, rgba(100, 116, 139, 0.15) 0%, transparent 70%)'
        }}
      />
      
      {/* Castle image */}
      <button
        onClick={onClick}
        disabled={!isUnlocked}
        className={`
          relative transition-all duration-500
          ${isUnlocked ? 'cursor-pointer hover:scale-[1.08] active:scale-100' : 'cursor-default'}
          ${!isUnlocked ? 'grayscale opacity-60' : ''}
        `}
        data-testid={`castle-course-${courseNumber}`}
      >
        <img 
          src={imageUrl} 
          alt={castleTitle}
          className={`${size} object-contain drop-shadow-2xl`}
          loading="eager"
        />
        
        {/* Sparkle effects for unlocked */}
        {isUnlocked && (
          <>
            <Sparkles 
              className="absolute -top-2 left-4 h-4 w-4 text-amber-400 animate-pulse" 
              style={{ animationDelay: '0.2s' }}
            />
            <Sparkles 
              className="absolute top-8 -right-2 h-3 w-3 text-yellow-400 animate-pulse" 
              style={{ animationDelay: '0.5s' }}
            />
          </>
        )}
      </button>
      
      {/* Castle label */}
      <div className="mt-4 text-center">
        <p className={`font-bold text-lg drop-shadow-lg ${isUnlocked ? 'text-amber-300' : 'text-slate-400'}`}>
          {castleTitle}
        </p>
        <p className="text-slate-500 text-sm">Lesson {lessonNumber}</p>
      </div>
    </div>
  );
}
